import axios from 'axios'
import api from './API'
import endpoints from './ApiEndpointConstants'

// 缓存和并发锁
let cachedWebsiteConfig = null;
let configPromise = null;

let cachedAllocatedPhone = null;
let phonePromise = null;

export const getWebsiteConfig = async () => {
  // 已缓存直接返回
  if (cachedWebsiteConfig) return cachedWebsiteConfig;
  // 有正在进行的请求，复用它
  if (configPromise) return configPromise;

  configPromise = (async () => {
    try {
      const host = window.location.host;
      const domain = host.includes('localhost') ? 'www.luxecraftshop.com' : host;
      const response = await axios.get(`https://webhook.manos-lux.com/api/websiteConfig/getByDomain`, {
        params: { domain }
      });
      cachedWebsiteConfig = response.data.data;
      return cachedWebsiteConfig;
    } catch (error) {
      console.error('获取网站配置失败:', error);
      throw error;
    } finally {
      configPromise = null;
    }
  })();

  return configPromise;
};

export const getAllocatedPhone = async () => {
  // 已缓存直接返回
  if (cachedAllocatedPhone !== null) return cachedAllocatedPhone;
  // 有正在进行的请求，复用它
  if (phonePromise) return phonePromise;

  phonePromise = (async () => {
    try {
      const host = window.location.host;
      const domain = host.includes('localhost') ? 'www.luxecraftshop.com' : host;
      const response = await axios.get(`https://webhook.manos-lux.com/api/websiteConfig/getAllocatedPhone`, {
        params: { domain }
      });
      cachedAllocatedPhone = response.data.data;
      return cachedAllocatedPhone;
    } catch (error) {
      console.error('获取分配电话失败:', error);
      // 失败时缓存 null，避免重复请求
      cachedAllocatedPhone = null;
      return null;
    } finally {
      phonePromise = null;
    }
  })();

  return phonePromise;
};

/**
 * 发送 Telegram 通知
 * 使用站点配置中的 telegram_group_id 作为目标群组
 * @param {string} text - 通知内容
 */
export const sendNotification = async (text) => {
  try {
    const config = await getWebsiteConfig();
    const telegramChatId = config?.telegram_group_id || '';
    if (!telegramChatId) {
      console.warn('sendNotification: 未配置 telegram_group_id，跳过通知');
      return;
    }
    return api.post(endpoints.SENDMESSAGE, {
      text,
      groupid: telegramChatId,
    }).catch(() => {});
  } catch (error) {
    // 静默失败，不影响主流程
  }
};
